export const FINDING_ACTIONS = {
  ACCEPT_RISK: "ACCEPT RISK",
  SUPPRESSED: "SUPPRESSED",
  TRIAGE: "TRIAGE",
  IN_PROGRESS: "IN_PROGRESS",
  CONTROLLED: "CONTROLLED",
  REJECT_RISK: "REJECT RISK",
  CONFIRMED: "CONFIRM",
  MITIGATED: "MITIGATED",
  NOT_CONFIRMED: "NOT CONFIRM",
  FALSEPOSITIVE: "FALSE POSITIVE",
  NOT_SUPPRESSED: "NOT_SUPPRESSED",
  NOT_TRIAGE: "NOT_TRIAGE",
  NOT_FALSEPOSITIVE: "NOT FALSE POSITIVE",
  NOT_IN_PROGRESS: "NOT_IN_PROGRESS",
  CHANGE_OWNER: "CHANGE OWNER",
  PROPOSE_FALSE_POSITIVE: "PROPOSE_FALSE_POSITIVE",
  PROPOSE_OPEN: "PROPOSE_OPEN",
  PROPOSE_CONFIRMED: "PROPOSE_CONFIRMED",
  PROPOSE_ACCEPTRISK: "PROPOSE_ACCEPTRISK",
  PROPOSE_SUPPRESSED: "PROPOSE_SUPPRESSED",
  PROPOSE_TRIAGE: "PROPOSE_TRIAGE",
  PROPOSE_IN_PROGRESS: "PROPOSE_IN_PROGRESS",
  PROPOSE_CONTROLLED: "PROPOSE_CONTROLLED",
  PROPOSE_MITIGATED: "PROPOSE_MITIGATED",
  PROPOSE_ASSIGNEE: "PROPOSE_ASSIGNEE",
  PROPOSE_DUE_DATE: "PROPOSE_DUE_DATE",
  PROPOSE_CATEGORY: "PROPOSE_CATEGORY",
  PROPOSE_SEVERITY: "PROPOSE_SEVERITY",
  PROPOSE_ACTION: "PROPOSE_ACTION",
  PROPOSE_BASIC_CHANGE: "PROPOSE_BASIC_CHANGE",
  PROPOSE_CUSTOM_FIELDS: "PROPOSE_CUSTOM_FIELDS",
  TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS:
    "TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS",
  ASSIGNED_OWNER: "ASSIGNED_OWNER",
  DUE_DATE_UPDATE: "DUE_DATE_UPDATE",
  TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK: "TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK",
  TAKE_ACTION_ON_PROPOSED_SUPPRESSED: "TAKE_ACTION_ON_PROPOSED_SUPPRESSED",
  TAKE_ACTION_ON_PROPOSED_TRIAGE: "TAKE_ACTION_ON_PROPOSED_TRIAGE",
  TAKE_ACTION_ON_PROPOSED_IN_PROGRESS: "TAKE_ACTION_ON_PROPOSED_INPROGRESS",
  TAKE_ACTION_ON_PROPOSED_CONTROLLED: "TAKE_ACTION_ON_PROPOSED_CONTROLLED",
  TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE:
    "TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE",
  TAKE_ACTION_ON_PROPOSED_OPEN: "TAKE_ACTION_ON_PROPOSED_OPEN",
  TAKE_ACTION_ON_PROPOSED_CONFIRMED: "TAKE_ACTION_ON_PROPOSED_CONFIRMED",
  TAKE_ACTION_ON_PROPOSED_DUE_DATE: "TAKE_ACTION_ON_PROPOSED_DUE_DATE",
  TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER: "TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER",
  TAKE_ACTION_ON_PROPOSED_MITIGATION: "TAKE_ACTION_ON_PROPOSED_MITIGATION",
  TAKE_ACTION_ON_PROPOSED_SEVERITY: "TAKE_ACTION_ON_PROPOSED_SEVERITY",
  TAKE_ACTION_ON_PROPOSED_CATEGORY: "TAKE_ACTION_ON_PROPOSED_CATEGORY",
  TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE: "TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE",
  ACTION_TAKEN: "ACTION_TAKEN",
};

// can be used to feature flag the finding actions
export const FINDING_ACTIONS_FLAGS = {
  CORRELATE_FINDINGS: "CORRELATED_FINDINGS",
};

export const REPORTED_ACTIONS = [
  FINDING_ACTIONS.REJECT_RISK,
  FINDING_ACTIONS.NOT_CONFIRMED,
  FINDING_ACTIONS.NOT_FALSEPOSITIVE,
];

export const FINDING_STATUS = {
  OPEN: "OPEN",
  TRIAGE: "TRIAGE",
  CONFIRMED: "CONFIRMED",
  IN_PROGRESS: "IN_PROGRESS",
  ACCEPT_RISK: "ACCEPTRISK",
  FALSE_POSITIVE: "FALSEPOSITIVE",
  SUPPRESSED: "SUPPRESSED",
  CONTROLLED: "CONTROLLED",
  MITIGATED: "MITIGATED",
  CHANGE_OWNER: "CHANGEOWNER",
};

export const GLOBAL_STATUS = {
  OPEN: "open",
  ACCEPTRISK: "acceptRisk",
  CONFIRMED: "confirmed",
  FALSEPOSITIVE: "falsePositive",
  MITIGATED: "mitigated",
  CHANGEOWNER: "Change Owner",
  SUPPRESSED: "suppressed",
  TRIAGE: "triageStatus",
  IN_PROGRESS: "inProgressStatus",
  CONTROLLED: "controlledStatus",
};

export const OPTIONAL_STATUS = {
  CREATE_TICKETS: "CREATE_TICKETS",
  EDIT_BASIC_DETAILS: "EDIT_BASIC_DETAILS",
  BULK_EDIT_DETAILS: "BULK_EDIT_DETAILS",
  CHANGE_CATEGORY: "CHANGE_CATEGORY",
  CHANGE_SEVERITY: "CHANGE_SEVERITY",
  CHANGE_DUE_DATE: "CHANGE_DUE_DATE",
  CHANGE_OWNER: "CHANGE_OWNER",
  MITIGATED: "MITIGATED",
  CLEAR_BUCKET: "CLEAR_BUCKET",
  CHANGE_PROJECTS: "CHANGE_PROJECTS",
  CORRELATE_FINDINGS: "CORRELATE_FINDINGS",
  DETACH_TICKET: "DETACH_TICKET",
  ADD_TO_EXCEPTION: "ADD_TO_EXCEPTION",
  ADD_TO_ASSESSMENT: "ADD_TO_ASSESSMENT",
};

export const FINDING_PROPOSED_STATUS = {
  ...FINDING_STATUS,
  PROPOSE_OPEN: "PROPOSE_OPEN",
  PROPOSE_CONFIRMED: "PROPOSE_CONFIRMED",
  PROPOSE_ACCEPTRISK: "PROPOSE_ACCEPTRISK",
  PROPOSE_SUPPRESSED: "PROPOSE_SUPPRESSED",
  PROPOSE_TRIAGE: "PROPOSE_TRIAGE",
  PROPOSE_IN_PROGRESS: "PROPOSE_IN_PROGRESS",
  PROPOSE_CONTROLLED: "PROPOSE_CONTROLLED",
  PROPOSE_MITIGATED: "PROPOSE_MITIGATED",
  PROPOSE_ASSIGNEE: "PROPOSE_ASSIGNEE",
  PROPOSE_DUE_DATE: "PROPOSE_DUE_DATE",
  PROPOSE_FALSE_POSITIVE: "PROPOSE_FALSE_POSITIVE",
  PROPOSE_CATEGORY: "PROPOSE_CATEGORY",
  PROPOSE_SEVERITY: "PROPOSE_SEVERITY",
  PROPOSE_BASIC_CHANGE: "PROPOSE_BASIC_CHANGE",
  PROPOSE_BULK_EDIT_DETAILS: "PROPOSE_BULK_EDIT_DETAILS",
  PROPOSE_CUSTOM_FIELDS: "PROPOSE_CUSTOM_FIELDS",
  TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK: "TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK",
  TAKE_ACTION_ON_PROPOSED_SUPPRESSED: "TAKE_ACTION_ON_PROPOSED_SUPPRESSED",
  TAKE_ACTION_ON_PROPOSED_TRIAGE: "TAKE_ACTION_ON_PROPOSED_TRIAGE",
  TAKE_ACTION_ON_PROPOSED_IN_PROGRESS: "TAKE_ACTION_ON_PROPOSED_IN_PROGRESS",
  TAKE_ACTION_ON_PROPOSED_CONTROLLED: "TAKE_ACTION_ON_PROPOSED_CONTROLLED",
  TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE:
    "TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE",
  TAKE_ACTION_ON_PROPOSED_OPEN: "TAKE_ACTION_ON_PROPOSED_OPEN",
  TAKE_ACTION_ON_PROPOSED_CONFIRMED: "TAKE_ACTION_ON_PROPOSED_CONFIRMED",
  TAKE_ACTION_ON_PROPOSED_DUE_DATE: "TAKE_ACTION_ON_PROPOSED_DUE_DATE",
  TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER: "TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER",
  TAKE_ACTION_ON_PROPOSED_MITIGATION: "TAKE_ACTION_ON_PROPOSED_MITIGATION",
  TAKE_ACTION_ON_PROPOSED_SEVERITY: "TAKE_ACTION_ON_PROPOSED_SEVERITY",
  TAKE_ACTION_ON_PROPOSED_CATEGORY: "TAKE_ACTION_ON_PROPOSED_CATEGORY",
  TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE: "TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE",
};

export const UNRESOLVED_FINDING_STATUS = [
  FINDING_STATUS.OPEN,
  FINDING_STATUS.ACCEPT_RISK,
  FINDING_STATUS.CONFIRMED,
];

export const RESOLVED_FINDING_STATUS = [
  FINDING_STATUS.MITIGATED,
  FINDING_STATUS.FALSE_POSITIVE,
  FINDING_STATUS.SUPPRESSED,
];

// Preserve typo NON_MITIDATED (sic) — renames are out of scope for ENG-122770 phase A.
export const NON_MITIDATED_FINDING_STATUS = [
  FINDING_STATUS.OPEN,
  FINDING_STATUS.ACCEPT_RISK,
  FINDING_STATUS.FALSE_POSITIVE,
  FINDING_STATUS.CONFIRMED,
  FINDING_STATUS.SUPPRESSED,
];

export const NON_FALSEPOSITIVE_FINDING_STATUS = [
  FINDING_STATUS.OPEN,
  FINDING_STATUS.ACCEPT_RISK,
  FINDING_STATUS.SUPPRESSED,
  FINDING_STATUS.MITIGATED,
  FINDING_STATUS.CONFIRMED,
];

export const NON_MITIGATED_NON_FALSEPOSITIVE = [
  FINDING_STATUS.OPEN,
  FINDING_STATUS.ACCEPT_RISK,
  FINDING_STATUS.CONFIRMED,
  FINDING_STATUS.IN_PROGRESS,
  FINDING_STATUS.TRIAGE,
];

export const FINDING_TICKET_STATUS = {
  TO_BE_CREATED: "TO_BE_CREATED",
  SCHEDULER_RAN: "SCHEDULER_RAN",
  ERROR_OCCURRED: "ERROR_OCCURRED",
  CREATED: "CREATED",
  DONE: "DONE",
  CREATE_FAILED: "CREATE_FAILED",
  UPDATE_FAILED: "UPDATE_FAILED",
};

export const FINDING_UPDATE_TASK_TYPES = {
  ACCEPT_RISK: "accept_risk",
  CONFIRMED: "confirmed",
  FALSE_POSITIVE: "false_positive",
  SUPPRESSED: "suppressed",
  OPEN: "open",
  TRIAGE: "triage",
  UPDATE_CATEGORY: "update_category",
  UPDATE_SEVERITY: "update_severity",
  IN_PROGRESS: "in_progress",
  CONTROLLED: "controlled",
  PROPOSE_OPEN: "propose_open",
  PROPOSE_CONFIRMED: "propose_confirmed",
  PROPOSE_ACCEPTRISK: "propose_accept_risk",
  PROPOSE_SUPPRESSED: "propose_suppressed",
  PROPOSE_FALSEPOSITIVE: "propose_false_positive",
  PROPOSE_MITIGATED: "propose_mitigated",
  PROPOSE_ASSIGNEE: "propose_owner",
  PROPOSE_DUE_DATE: "propose_due_date",
  PROPOSE_TRIAGE: "propose_triage",
  PROPOSE_IN_PROGRESS: "propose_in_progress",
  PROPOSE_CONTROLLED: "propose_controlled",
  PROPOSE_CUSTOM_FIELDS: "propose_custom_fields",
};

export const DEFAULT_STATUS_FILTERS = [
  FINDING_STATUS.OPEN,
  FINDING_STATUS.ACCEPT_RISK,
  FINDING_STATUS.CONFIRMED,
];

export const VOCABULARY_STATUS = [
  "open",
  "confirmed",
  "acceptRisk",
  "falsePositive",
  "mitigated",
  "suppressed",
  "triageStatus",
  "inProgressStatus",
  "controlledStatus",
];

type FindingAnalysisType = {
  STATIC: "SAST";
  DYNAMIC: "DAST";
  NA: "N/A";
  [key: string]: string;
};

export const FINDING_ANALYSIS_TYPE: FindingAnalysisType = new Proxy(
  {
    STATIC: "SAST",
    DYNAMIC: "DAST",
    NA: "N/A",
  } as FindingAnalysisType,
  {
    get: (target, prop: string) => {
      return target?.[prop] ?? target.NA;
    },
  },
);
